<div class="flex flex-col md:flex-row gap-2 w-full">
  <div class="md:flex-1 w-full md:w-auto">
    @if (periodFromControl(); as periodFromControl) {
      <albert-datepicker
        [controlName]="controlName()"
        [disabled]="disabled()"
        [groupName]="periodFromGroupName()"
        [inputId]="periodFromInputId()"
        [label]="periodFromLabel()"
        [required]="required()"
      />
    }
  </div>
  <div class="md:flex-1 w-full md:w-auto">
    @if (periodToControl(); as periodToControl) {
      <albert-datepicker
        [controlName]="controlName()"
        [disabled]="disabled()"
        [groupName]="periodToGroupName()"
        [inputId]="periodToInputId()"
        [label]="periodToLabel()"
        [required]="required()"
      />
    }
  </div>
</div>
